import { defineStore } from "pinia";

import notesService from "@/services/modules/notes";

import type { IResponseLinks, IResponseMeta } from "@/models/common";
import type {
  NoteFilterParams,
  NotePayload,
  NotesResource,
} from "@/models/notes";

interface UseNotesState {
  currentNotes: NotesResource;
  activeNoteDealId: string | null;
  activeNoteBusinessDealId: number | null;
  isDealActivityPipModeActivated: boolean;
}
const getDefaultState = (): UseNotesState => ({
  currentNotes: {
    data: [],
    meta: {} as IResponseMeta,
    links: {} as IResponseLinks,
  },
  activeNoteDealId: null,
  activeNoteBusinessDealId: null,
  isDealActivityPipModeActivated: false,
});

const useNotesStore = defineStore("notes", {
  state: getDefaultState,
  actions: {
    async getNotes(params: NoteFilterParams) {
      const currentParams: NoteFilterParams = {
        ...params,
        application_ids:
          this.isDealActivityPipModeActivated && this.activeNoteDealId
            ? [this.activeNoteDealId]
            : params.application_ids,
      };
      const notes = await notesService.getNotes(currentParams);
      this.currentNotes = notes.data;
    },
    async createNote(payload: NotePayload) {
      const currentPayload: NotePayload = {
        ...payload,
        notable_id: this.getNotableId(payload.notable_id),
      };
      await notesService.createNote(currentPayload);
    },
    async updateNote(payload: NotePayload) {
      const currentPayload: NotePayload = {
        ...payload,
        notable_id: this.getNotableId(payload.notable_id),
      };
      if (!payload.id) {
        return;
      }
      await notesService.updateNote(currentPayload);
    },
    resetNotes() {
      if (this.isDealActivityPipModeActivated) {
        return;
      }
      this.currentNotes = getDefaultState().currentNotes;
    },

    getNotableId(notableId: string | number | undefined) {
      if (!this.isDealActivityPipModeActivated) {
        return notableId;
      }

      return (
        this.activeNoteBusinessDealId ?? this.activeNoteDealId ?? undefined
      );
    },
  },
});

export default useNotesStore;
